import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { FadeInUp } from '../animations';

const CTASection = ({
  sectionTestId, linkTestId, bgClass, title, titleClass,
  description, descriptionClass, buttonClass,
}) => (
  <section className={`py-24 lg:py-32 ${bgClass}`} data-testid={sectionTestId}>
    <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
      <FadeInUp>
        <h2 className={`text-3xl sm:text-4xl font-bold tracking-tight mb-4 ${titleClass}`} style={{ fontFamily: 'Cabinet Grotesk' }}>
          {title}
        </h2>
        <p className={`text-base leading-relaxed mb-8 ${descriptionClass}`}>
          {description}
        </p>
        <Link
          to="/request-sourcing"
          className={`inline-flex items-center gap-2 px-10 py-4 text-sm font-semibold tracking-wider uppercase transition-all hover:shadow-xl hover:-translate-y-0.5 ${buttonClass}`}
          data-testid={linkTestId}
        >
          Request Sourcing <ArrowRight size={18} />
        </Link>
      </FadeInUp>
    </div>
  </section>
);

export default CTASection;
